import * as React from 'react'

import {
  Box,
  type Colors,
  Icon,
  Text,
  Tooltip,
  useToggle,
} from '@factorialco/deprecated-design-system'

import formatCurrency from 'modules/core/lib/formatCurrency'
import { currencyToNumber, isValidAmount } from 'modules/core/lib/formatCurrencyUtils'
import i18n from 'modules/core/lib/i18n'

interface LabelProps {
  label: string
  text?: React.ReactNode
}

const TooltipDialog = ({ label, text }: LabelProps) => {
  const [open, toggle] = useToggle(false)

  return (
    <Tooltip.Dialog
      open={open}
      toggle={toggle}
      attachment="top center"
      label={label}
      textAlign="center"
    >
      {text || <Icon.Medium icon="alert-circle" />}
    </Tooltip.Dialog>
  )
}

interface SalaryProps {
  salary: string
  color?: Colors
  label?: string
  updateLabel?: React.ReactNode | null
}

const Salary = ({ salary, color, label, updateLabel }: SalaryProps) => {
  const [open, toggle] = useToggle(false)

  if (salary) {
    const trimmedSalary = String(salary).trim()

    if (updateLabel && isValidAmount(trimmedSalary)) {
      const value = formatCurrency(currencyToNumber(trimmedSalary) * 100)

      return (
        <Tooltip.Alt attachment="top center" open={open} toggle={toggle} label={updateLabel}>
          <Text.Normal>{value}</Text.Normal>
        </Tooltip.Alt>
      )
    }

    if (isValidAmount(trimmedSalary)) {
      const value = formatCurrency(currencyToNumber(trimmedSalary) * 100)

      return <Text.Normal color={color}>{value}</Text.Normal>
    }

    const invalidTooltipLabel = i18n.t('payroll_bundle.sepa_generator.matcher.invalid_salary')

    return (
      <Box flexDirection="row" alignItems="center" justifyContent="flexStart">
        <Text.Normal weight="medium" color="radicalRed1200" stroked>
          {salary}
        </Text.Normal>
        <TooltipDialog label={invalidTooltipLabel} />
      </Box>
    )
  }

  const tooltipLabel = label || i18n.t('payroll_bundle.sepa_generator.matcher.no_salary')

  return (
    <Box flexDirection="row" alignItems="center">
      <TooltipDialog label={tooltipLabel} text={<Text.Normal color={color}>--</Text.Normal>} />
    </Box>
  )
}

export default Salary
